export default __webpack_public_path__ + "static/media/notification.fdda1bf1.mp3";